import React from "react";
import { Alert, Card, Col, Row, Table, Badge, Image } from "react-bootstrap";
import ModuleRecordsPerPageDropdown from "../../../../UI/modules/views/partials/common/ModuleRecordsPerPageDropdown";
import ModuleSearchBox from "../../../../UI/modules/views/partials/common/ModuleSearchBox";
import ModuleStatusDropdown from "../../../../UI/modules/views/partials/common/ModuleStatusDropdown";
import ModuleDynamicFilterDropdown from "../../../../UI/modules/views/partials/common/ModuleDynamicFilterDropdown";

const SearchArea = ({
  moduleConfig,
  setFilter,
  appliedFilters,
  resetFilters,
}) => {
  //console.log(appliedFilters);
  return (
    <>
      {(appliedFilters.limit ||
        appliedFilters.q ||
        appliedFilters.to ||
        appliedFilters.importance) && (
        <div
          div
          className="resetFilters text-right"
          onClick={() => resetFilters()}
        >
          <span>
            <i className="fas fa-times" /> Reset Filters
          </span>
        </div>
      )}

      <Card className="listingPageHeader p-0 m-0 p-1 mt-2 mb-1">
        <Card.Body className=" p-0 m-0">
          <Row className="mb-0">
            {moduleConfig.hasPagination === true &&
              moduleConfig.perPageItemsOptions &&
              moduleConfig.perPageItemsOptions.length > 0 && (
                <Col className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 col-12 pt-xl-0 pt-lg-0 pt-md-0 pt-0">
                  <ModuleRecordsPerPageDropdown
                    selectedPerPageItems={moduleConfig.perPageItems}
                    perPageItemsOptions={moduleConfig.perPageItemsOptions}
                    setFilter={setFilter}
                  />
                </Col>
              )}

            <Col className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 col-12 pt-xl-0 pt-lg-0 pt-md-0 pt-1">
              <ModuleDynamicFilterDropdown
                filterField="importance"
                setFilter={setFilter}
                appliedFilters={appliedFilters}
                options={[
                  {
                    label: "Select By Importance...",
                    value: "",
                  },
                  {
                    label: "Low",
                    value: "low",
                  },
                  {
                    label: "Medium",
                    value: "medium",
                  },
                  {
                    label: "High",
                    value: "high",
                  },
                ]}
              />
            </Col>
            <Col className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 col-12 mt-1 pt-xl-0 pt-lg-0 pt-md-0 pt-1">
              <ModuleDynamicFilterDropdown
                filterField="to"
                setFilter={setFilter}
                appliedFilters={appliedFilters}
                options={[
                  {
                    label: "Select By Type...",
                    value: "",
                  },
                  {
                    label: "Meal Subscribers",
                    value: "All Meal Subscribers",
                  },
                  {
                    label: "Active Meal Subscribers",
                    value: "Active Meal Subscribers",
                  },
                  {
                    label: "Expired Meal Subscriptions",
                    value: "Expired Meal Subscribers",
                  },
                  {
                    value: "Product Buyers",
                    label: "Product Buyers",
                  },
                  {
                    value: "Customers With No Subscription",
                    label: "Customers With No Subscription",
                  },
                ]}
              />
            </Col>

            {moduleConfig.hasSearch === true && (
              <Col className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 col-12 mt-1 pt-xl-0 pt-lg-0 pt-md-0 pt-1">
                <ModuleSearchBox
                  setFilter={setFilter}
                  appliedFilters={appliedFilters}
                />
              </Col>
            )}
          </Row>
        </Card.Body>
      </Card>
    </>
  );
};

export default SearchArea;
